//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTime } from '../../components/helpers'

export default {
  components: {
  },
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    showActiveInitiatedField: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      columnsInitial: [
        {
          name: 'name',
          label: 'Номер',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'createTime',
          label: 'Дата создания',
          align: 'left',
          field: 'createTime',
          format: value => value ? formatTime(value) : '',
          sortable: true
        },
        {
          name: 'stateName',
          label: 'Статус',
          align: 'left',
          field: 'stateName',
          sortable: true
        },
        {
          name: 'typeName',
          label: 'Тип',
          align: 'left',
          field: 'typeName',
          sortable: true
        },
        {
          name: 'objectNumber',
          label: 'Номер объекта',
          align: 'left',
          field: 'objectNumber',
          sortable: true
        },
        {
          name: 'objectType',
          label: 'Тип объекта',
          align: 'left',
          field: 'objectType',
          sortable: true
        },
        {
          name: 'external',
          label: 'Внешняя/Внутренняя',
          align: 'left',
          field: 'external',
          format: (value) => value ? 'Внешняя' : 'Внутренняя',
          sortable: true
        },
        {
          name: 'applicantDescription',
          label: 'Описание от заявителя',
          align: 'left',
          field: 'applicantDescription',
          style: 'width: 35%',
          sortable: true
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0 // все строки
      }
    }
  },
  computed: {
    columns: function () {
      if (this.showActiveInitiatedField) {
        return this.columnsInitial.concat([
          {
            name: 'typeActiveInitiated',
            label: 'Активная/Инициируемая',
            align: 'left',
            field: 'typeActiveInitiated',
            format: (value) => value === 'active' ? 'Активная' : value === 'initiated' ? 'Инициируемая' : '',
            sortable: true
          }
        ])
      } else {
        return this.columnsInitial
      }
    }
  }
}

